/**
 * The public ticket shapes and words, shared by the server routes and the
 * buyer screens (Event Tickets plan 2026-10-19, U4, U5). Pure: no server
 * imports, so the browser bundle can use it.
 */

export const PUBLIC_TICKETS_COPY = {
  NOT_FOUND: "We couldn't find this event.",
  SOLD_OUT: 'Sold out',
  SALES_CLOSED: 'Ticket sales have closed.',
  ALL_HELD: 'The last tickets are in other buyers’ checkouts. Any they don’t buy go back on sale.',
  DEMO: 'This is a demo gym. Tickets can’t be bought here.',
  NOT_TAKING_PAYMENTS: 'This event can’t take payments right now. Please contact the gym.',
  CART_CHANGED: 'The tickets for this event changed. Please pick again.',
  START_FAILED: 'We couldn’t start your order. Please try again.',
  LOAD_FAILED: 'We couldn’t load this event. Please try again.',
  ALREADY_STARTED: 'This order is already being placed.',
  OVER_ORDER_MAX: (max: number) => `You can buy up to ${max} tickets in one order.`,
  START_OVER: 'Your hold on these tickets ran out. Please start again.',
} as const;

/** Refusal codes the buyer's screen acts on. */
export const TICKET_CHECKOUT_CODES = {
  SOLD_OUT: 'sold_out',
  SALES_CLOSED: 'sales_closed',
  CART_CHANGED: 'cart_changed',
  START_OVER: 'start_over',
  ALREADY_PAID: 'already_paid',
} as const;

export type PublicSalesState = 'on_sale' | 'sold_out' | 'sales_closed' | 'all_held';

export interface PublicTicketType {
  id: string;
  name: string;
  price_cents: number;
  /** One ticket with the buyer's fee share in it, before tax (R10). */
  all_in_price_cents: number;
  /** Tickets of this type that can still be bought now (room limit applied). */
  left: number;
}

export interface PublicTicketedEvent {
  id: string;
  title: string;
  description: string | null;
  cover_image_url: string | null;
  cover_image_alt: string | null;
  start_time: string;
  end_time: string;
  is_all_day: boolean;
  time_zone: string;
  venue_name: string | null;
  venue_address: string | null;
  host_location_name: string | null;
  /** The venue is not one of the gym's locations, so "Hosted by" is worth saying. */
  outside_venue: boolean;
  /** The earlier of the stop time and the event end (R37). */
  sales_end_at: string;
  sales_state: PublicSalesState;
  per_order_max: number;
  sales_tax_percent: number;
  /** True when the buyer pays any fee, so prices say "fees included". */
  fees_included: boolean;
  seats_left: number;
  types: PublicTicketType[];
  min_all_in_cents: number | null;
  max_all_in_cents: number | null;
}

